import { Component, Input, OnInit } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { Transactions } from "src/app/models/transactions.model";
import { DataExchangeService } from "src/app/services/dataExchange.service";
import { PaymentService } from "src/app/services/payment.service";
import { QrGeneratorService } from "src/app/services/qrGenerator.service";
import { SignalRService } from "src/app/services/signalR.service";
import { ERR_MESSAGE } from "../../constants/error";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-main",
  templateUrl: "./main.component.html",
  styleUrls: ["./main.component.css"],
})
export class MainComponent implements OnInit {
  @Input() type!: string;

  public transaction: Transactions;
  public merchantInfo: any;

  public transferID: string;
  public getNotification: Subscription;

  public isLoading: boolean = true;
  public transactionLanguage: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private paymentService: PaymentService,
    private translateService: TranslateService,
    private signalRService: SignalRService,
    private dataExService: DataExchangeService,
    private _snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.signalRService.startConnection(localStorage.getItem("token"));
    setTimeout(() => {
      this.signalRService.listenerWS();
    }, 1000);

    if (this.type == "400") {
      this.route.queryParamMap.subscribe((param) => {
        this.transferID = param.get("transactionId");
        this.getTransaction(this.transferID);
      });
    } else {
      this.route.paramMap.subscribe((param) => {
        this.transferID = param.get("id");
        this.getTransaction(this.transferID);
      });
    }
  }

  getTransaction(id: string) {
    this.isLoading = true;

    this.paymentService.getTransaction(id).subscribe({
      next: (data) => {
        let body = data.body as any;
        this.transaction = body.transaction;
        this.merchantInfo = body?.merchantUser?.merchantInfo;
        this.signalRService.addData(
          body?.merchantUser?.merchantUserId?.toString()
        );

        this.transactionLanguage =
          this.transaction.language == "hy"
            ? "am"
            : this.transaction.language.trim() == ""
            ? "am"
            : this.transaction.language;

        localStorage.setItem("lang", this.transactionLanguage);
        if (
          this.transaction.isBlocked ||
          this.transaction.transactionStatus == 3 ||
          this.transaction.transactionStatus == 4
        ) {
          this.router.navigateByUrl(`transaction-not-found/${this.transferID}`);
          this.isLoading = false;
          return;
        }

        setTimeout(() => {
          this.getNotification = this.dataExService.getNotification().subscribe(
            (res) => {
              console.log("qr res", res);
              if (res["isPaid"] == "true") {
                // this.router.navigateByUrl(`en/px_transfer?transfer_id=${res['transactionId']}`)
                window.location.href = `en/px_transfer?transfer_id=${res["transactionId"]}`;
              }
            },
            (err) => {
              let errmer = err?.error?.message?.trim();
              this._snackBar.open(errmer || ERR_MESSAGE, "", {
                duration: 2000,
              });
            }
          );
        }, 1000);

        this.translateService.use(localStorage.getItem("lang"));

        if (this.transaction.transactionStatus == 2) {
          this.router.navigateByUrl(`transfer_success/${this.transferID}`);
          this.isLoading = false;
          return;
        }
        this.isLoading = false;
      },
      error: () => {},
    });
  }

  onOutletLoaded(component: any) {
    component.transaction = this.transaction;
    component.transferID = this.transferID;
  }
}
